module.exports = __webpack_public_path__ + "img/IT0000393168566.83296104.png";